import { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { Row, Tabs } from 'antd'
import AppLayout from '../../../../components/layout/layout'
import NewFamily from '../../../Modals/FamilyModal/NewFamily/NewFamily'
import MemberTab from './FamilyMembers/MemberTab'
import Events from './Events/Events'
// import Notes from './Notes/Notes'
import Notes from '../NotesComp/Notes'
import Organizations from './Organizations/Organizations'
import History from './History/History'
import { useGetFamily } from '../../../../api/family'
import FamilyHeader from './FamilyHeader/FamilyHeader'
import Spinner from '../../../../components/Spinner'
import Payments from './Payments/Payments'
import Stripe from './Stripe/Stripe'
import { useGetSearchParams } from 'hooks/useGetSearchParams'
const { TabPane } = Tabs

const FamilyProfile = () => {
  const history = useHistory()
  const [showEditFamily, setShowEdit] = useState<boolean>(false)

  let { id }: any = useParams()
  // const { isLoading, data, refetch } = useQuery(['getFamilyData'], () =>
  //   GetFamily(id),
  // )
  const { isLoading, data, refetch, isFetching } = useGetFamily(id)
  const params = useGetSearchParams(['tab'])

  const handleTabChange = (key: string) => {
    if (key === 'events') {
      history.push(`?tab=events&page=1&limit=20`)
    } else {
      history.push(`?tab=${key}`)
    }
  }

  return (
    <AppLayout id={id}>
      {isLoading || isFetching ? (
        <div className="flex justify-center items-center h-full aligin-center">
          <Spinner />
        </div>
      ) : (
        <div className="bg-grey">
          <FamilyHeader
            FamilyDetails={data}
            setShowEdit={setShowEdit}
            refetch={refetch}
          />
          <Row>
            <Tabs
              activeKey={params.tab || 'members'}
              style={{ width: '100%', height: '100%' }}
              className="bg-white profile-tabs"
              onChange={handleTabChange}
            >
              <TabPane tab="Members" key="members">
                <MemberTab
                  FamiliyData={data}
                  isLoading={isLoading}
                  refetch={refetch}
                />
              </TabPane>
              <TabPane tab="Organizations" key="organizations">
                <Organizations />
              </TabPane>
              <TabPane tab="Events" key="events">
                <Events familyId={id} />
              </TabPane>
              <TabPane tab="History" key="history">
                <History familyId={id} />
              </TabPane>
              <TabPane tab="Notes" key="notes">
                {/* <Notes familyId={id} /> */}
                <Notes id={id} familyId={id} />
              </TabPane>
              <TabPane tab="Payments" key="payments">
                <Payments familyId={id}></Payments>
              </TabPane>
              <TabPane tab="Stripe Payment" key="stripe-payment">
                <Stripe familyId={id}></Stripe>
              </TabPane>
            </Tabs>
          </Row>
        </div>
      )}
      {showEditFamily && (
        <NewFamily
          familyData={data}
          refetchData={refetch}
          showModal={setShowEdit}
        />
      )}
    </AppLayout>
  )
}

export default FamilyProfile
